import { Badge, Text, InlineStack, Page, Popover, Layout, Card, BlockStack, Bleed, Divider, Tag, Icon, Link, DataTable, Box } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { ChevronDownMinor, CircleCancelMinor, CircleTickMinor, DiamondAlertMajor, ExternalSmallMinor } from '@shopify/polaris-icons';
import { ShopifySquareIcon } from '../../../../../Asests/svgIcon/icon';
import '../../Styles/NewStyles.css';
import BannerCarousel from './BannerCarousel';
import OrderDetails from './OrderDetails';
import { DI, DIProps } from '../../../../../Core';
import { formatDateForOrderCreation, formattedOrderSummaryDate, getAmazonStatusBadgeColor, getAmazonStatusBadgeProgress, getShopifyOrderId, getShopifyShopUrl, getSourceShopID, getStatus, getSyncStatus, getTags } from '../../Utils/Helper';
import { countryWithDemonym } from '../../../../../Components/Panel';
import { useTranslation } from 'react-i18next';
import OrderViewSkeleton from '../../Utils/skeleton/OrderViewSkeleton';
import { RenderHeadersAction } from '../../../Panel';

interface props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const ViewOrders = (props: props) => {
    const { t } = useTranslation();
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const country = countryWithDemonym[props?.redux?.current?.target?.warehouses?.[0]?.marketplace_id].country
    const [order_row, setOrderRow] = useState<any>({});
    let { amazonStatus, shopifyStatus } = getStatus(order_row, props);

    let orderId = getShopifyOrderId(order_row);
    let shopUrl = getShopifyShopUrl(orderId, props);
    let [currentOrderIdCount, setCurrentOrderCount] = useState<number>(0);
    const [popoverActive, setPopoverActive] = useState(false);
    const [loader, setLoader] = useState<boolean>(true);
    const [params, setParams] = useState<any>({});
    // const [currentOrderId, setCurrentOrderId] = useState<string>("0");

    useEffect(() => {
        getOrderData(false)
        paramsToObj(props.location.search);
        // setCurrentOrderId(props.match?.['o_id'] ?? "N/A")
    }, [])

    useEffect(() => {
        setCurrentOrderCount((+params?.page - 1) * +params?.size + +params?.current)
    }, [params])

    /**
    * Parses a string of URL parameters into an object.
    * @param {string} params - The string of URL parameters to be parsed.
    * @returns {void} This function does not return a value, but sets the parsed parameters into a state variable.
    */
    const paramsToObj = (params: string): void => {
        const paramObj: any = {};
        const parameters = params.replace("?", "").split('&');
        for (let i = 0; i < parameters.length; i++) {
            const [key, value] = parameters[i].split('=');
            paramObj[key] = value;
        }
        setParams(paramObj)
    }



    const [shippingData, setshippingData] = useState<any>([])
    const getShipmentDetails = (data: any) => {
        const obj = {
            "filter": {
                "user_id": {
                    "1": data?.user_id
                },
                "object_type": {
                    "11": "source_shipment,target_shipment"
                },
                "cif_order_id": {
                    "1": data?.cif_order_id
                }
            },
            "projection": {
                "marketplace": 1,
                "shipment_id": 1,
                "reference_id": 1,
                "object_type": 1,
                "tracking": 1,
                "shipping_method": 1
            }
        }
        props.di.POST("connector/order/getAll", obj).then((response: any) => {
            let pair = []
            if (response.success) {
                let groupedData = response?.data?.rows?.reduce((acc: any, item: any) => {
                    const refId = item.reference_id ?? item?.shipment_id;
                    if (!acc[refId]) {
                        acc[refId] = {};
                    }

                    acc[refId][item.marketplace] = item.tracking;
                    return acc;
                }, {});
                groupedData = Object.values(groupedData);
                setshippingData(groupedData)

            }
        })

    }

    /**
     * Retrieves order data based on pagination and count parameters.
     * @param {boolean} pagination - Indicates whether pagination is enabled.
     * @param {number} [count] - The count of orders to retrieve when pagination is enabled.
     * @returns {void} This function does not return a value directly but sets state and performs API requests.
     */
    const getOrderData = (pagination: boolean, count?: number): void => {
        setLoader(true)
        let obj: any = {
            "filter": {
                "user_id": { "1": props.redux.user_id },
                "object_type": { "1": "source_order" },
                "marketplace": { "1": props?.redux?.current?.target?.marketplace },
                "marketplace_shop_id": { "1": props?.redux?.current?.target?._id }
            }
        };
        if (!pagination) obj["filter"]["marketplace_reference_id"] = { "1": props?.match?.o_id }
        else if (count) {
            obj['activePage'] = +count
            obj['count'] = 1
        }
        props.di.POST("connector/order/getAll", obj).then((response: any) => {
            setLoader(false)
            if (response?.success) {
                setOrderRow({ ...response?.data?.rows?.[0] })
                if (Object.keys(response?.data?.rows?.[0])?.includes("shipping_status") && response?.data?.rows?.[0]?.['shipping_status']?.includes("Shipped")) {
                    getShipmentDetails({ ...response?.data?.rows?.[0] })
                }
                if (count) props.history(`../viewOrder/${response?.data?.rows?.[0]?.marketplace_reference_id}?total=${params?.total}&page=${Math.ceil(count / +params?.size)}&size=${params?.size}&current=${count % +params?.size !== 0 ? count % +params?.size : 10 < 11 ? count % +params?.size !== 0 ? count % +params?.size : 10 : 1}`)
            }
            else props.error(t(response?.message))
        })
    }

    /**
     * Generates a sync status badge based on the primary status.
     * @param {string} primaryStatus - The primary status of the order sync.
     * @returns {React.ReactNode} Returns a JSX element representing the sync status badge.
     */
    const syncStatusBadge = (primaryStatus: any): React.ReactNode => {
        let id: string = '';
        if (order_row?.targets) {
            id = order_row?.targets?.map((target: any) => {
                if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                    return target?.order_id;
                }
            })
        }
        switch (primaryStatus) {
            case 'Created':
                return (
                    <InlineStack gap="100" blockAlign='center'>
                        <div><Icon source={CircleTickMinor} tone="success" /></div>
                        <Text variant="bodySm" as="p">{t(primaryStatus)}</Text>
                    </InlineStack>
                );
            case 'Order':
                return (
                    <div className='Custom__Error--Icon'>
                        <Badge icon={DiamondAlertMajor} tone="critical">{t(primaryStatus)}</Badge>
                    </div>
                )
            case 'Shipment':
                return (
                    <div className='Custom__Error--Icon'>
                        <Badge icon={DiamondAlertMajor} tone="critical">{t(primaryStatus)}</Badge>
                    </div>
                )
            case 'Cancellation':
                return (
                    <div className='Custom__Error--Icon'>
                        <Badge icon={DiamondAlertMajor} tone="critical">{t(primaryStatus)}</Badge>
                    </div>
                )
            case 'Refund':
                return (
                    <div className='Custom__Error--Icon'>
                        <Badge icon={DiamondAlertMajor} tone="critical">{t(primaryStatus)}</Badge>
                    </div>
                )
            case 'Cancelled':
                return (
                    <InlineStack gap="100" blockAlign='center'>
                        <div><Icon source={CircleCancelMinor} tone="caution" /></div>
                        <Text variant='bodySm' as='p'>{t(primaryStatus)}</Text>
                    </InlineStack>
                );
            case 'Refunded':
                return (
                    <InlineStack gap="100" blockAlign='center'>
                        <div><Icon source={CircleTickMinor} tone="success" /></div>
                        <Text variant="bodySm" as="p">{t(primaryStatus)}</Text>
                    </InlineStack>
                );
        }
    }

    /**
  * Renders the structure for displaying sync status.
  * @returns {React.ReactNode} Returns a JSX element representing the sync status structure.
  */
    const renderSyncStatusStructure = (): React.ReactNode => {
        let render: React.ReactNode = <></>;
        // Get sync status details
        let { primaryStatus, remainingCount, remaingingStatus } = getSyncStatus(order_row, props);
        // Render structure based on remaining count
        if (remainingCount > 0) {
            render = (
                <InlineStack gap="200" blockAlign='center'>
                    {syncStatusBadge(primaryStatus)}  {/* Render primary status badge */}
                    <Text as="p" fontWeight="bold">+{remainingCount}</Text>  {/* Render remaining count */}
                    {/* Render popover for remaining statuses */}
                    <Popover
                        active={popoverActive}
                        preferredAlignment="right"
                        activator={<div onClick={() => setPopoverActive(!popoverActive)}><Icon source={ChevronDownMinor} tone="subdued" /></div>}
                        autofocusTarget="first-node"
                        onClose={() => setPopoverActive(!popoverActive)}
                    >
                        <Card padding="300">
                            {/* Map and render remaining statuses */}
                            {remaingingStatus?.map((status: any, idx: number) => (
                                <React.Fragment key={idx}>{syncStatusBadge(status)}</React.Fragment>
                            ))}
                        </Card>
                    </Popover>
                </InlineStack>
            );
        } else {
            // Render only primary status badge if no remaining statuses
            render = <React.Fragment>{syncStatusBadge(primaryStatus)}</React.Fragment>;
        }

        return render;
    }

    /**
     * Renders the structure for displaying tags.
     * @returns {React.ReactNode} Returns a JSX element representing the tag structure.
     */
    const renderTagStructure = (): React.ReactNode => {
        let render: React.ReactNode = <></>;
        let { primaryTag, remainingCount, remaingingTags } = getTags(order_row);
        if (primaryTag !== '') {
            if (remainingCount > 0) {
                render = <InlineStack gap="200" blockAlign='center' key={'count>0'}>
                    <Tag>{t(primaryTag)}</Tag>
                    {remaingingTags?.map((tags: any, idx: number) => <Tag key={idx}>{tags}</Tag>)}
                </InlineStack>
            }
            else render = <InlineStack gap="200" blockAlign='center' key={'else'}>
                <Tag>{t(primaryTag)}</Tag>
            </InlineStack>
        }
        else render = <Text as='p'>{t("N/A")}</Text>

        return render;
    }

    function TrackingInfoTable({ trackingData }: any) {
        return (
            <div>
                {shippingData.map((entry: any, index: any) => (
                    <Card >
                        <BlockStack gap={'400'}>
                            <Text as='p' variant='headingMd'> Shipping details</Text>
                            <Layout>
                                <Layout.Section variant='oneHalf'>
                                    <Box padding={'200'} background="bg-surface-secondary" >
                                        <BlockStack gap={'100'}>
                                            <Text variant="headingMd" as="p">Shopify</Text>
                                            {entry.shopify ? (
                                                <BlockStack gap={'025'}>
                                                    <Text as="p"><strong>Company:</strong> {entry.shopify.company}</Text>
                                                    <Text as="p"><strong>Tracking Number:</strong> {entry.shopify.number}</Text>
                                                    <Text as="p"><strong>URL:</strong> <a href={entry.shopify.url} target="_blank" rel="noopener noreferrer">{entry.shopify.url}</a></Text>
                                                </BlockStack>
                                            ) : (
                                                <Text as="p">No Shopify data available</Text>
                                            )}
                                        </BlockStack>
                                    </Box>
                                </Layout.Section>
                                <Layout.Section variant='oneHalf'>
                                    <Box padding={'200'} background="bg-surface-secondary" >
                                        <BlockStack gap={'100'}>
                                            <Text variant="headingMd" as="h2">Amazon</Text>
                                            {entry.amazon ? (
                                                <BlockStack gap={'025'}>
                                                    <Text as="p"><strong>Company:</strong> {entry.amazon.company}</Text>
                                                    <Text as="p"><strong>Tracking Number:</strong> {entry.amazon.number}</Text>
                                                    <Text as="p"><strong>URL:</strong> <a href={entry.amazon.url} target="_blank" rel="noopener noreferrer">{entry.amazon.url}</a></Text>
                                                </BlockStack>
                                            ) : (
                                                <Text as="p">No Amazon data available</Text>
                                            )}
                                        </BlockStack>
                                    </Box>
                                </Layout.Section>

                            </Layout>
                        </BlockStack>
                    </Card>

                ))}
            </div>
        );
    }

    const [shopifyorderId, setshopifyorderId] = useState('')

    useEffect(() => {

        let obj: any = {
            'filter[user_id][1]': props.redux.user_id,
            'filter[object_type][1]': "target_order",
            'filter[marketplace][1]': props?.redux?.current?.source?.marketplace,
            'filter[marketplace_shop_id][1]': props?.redux?.current?.source?._id,
            "filter[marketplace_reference_id][1]": orderId
        }
        orderId && props.di.GET('connector/order/getAll', obj).then((response: any) => {
            if (response.success) {
                setshopifyorderId(response?.data?.rows?.[0]?.order_name)
            } else {
                props.error(response.message ?? "No response from API")
            }
            // setshopifyorderId()
            // setShowSkeleton(false);
            // if (response?.success) setShopifyOrder({ ...response?.data?.rows?.[0] });
        })

    }, [orderId])


    return (
        <div className='Custom__Page--Headers'>
            {
                loader ?
                    <OrderViewSkeleton row={order_row} months={months} country={country} />
                    :
                    <Page
                        fullWidth
                        backAction={{ content: 'orderGrid', onAction: () => props.history('../allSales') }}
                        title={props.match?.['o_id'] || "N/A"}
                        titleMetadata={
                            <InlineStack gap="600" align='center'>
                                <InlineStack gap="200">
                                    {
                                        order_row?.marketplace_status === "Unshipped" || order_row?.marketplace_status === "Shipped" || order_row?.marketplace_status === "Partially Shipped" ?
                                            <Badge progress={getAmazonStatusBadgeProgress(order_row?.marketplace_status)} tone={getAmazonStatusBadgeColor(order_row?.marketplace_status)}>
                                                {t(amazonStatus)}
                                            </Badge>
                                            :
                                            <Badge tone={getAmazonStatusBadgeColor(order_row?.marketplace_status)}>
                                                {t(amazonStatus)}
                                            </Badge>
                                    }
                                    {renderSyncStatusStructure()}
                                </InlineStack>
                                <div className='Custom__Divider--Section'>
                                    <InlineStack gap="200" blockAlign='center'>
                                        <ShopifySquareIcon />
                                        <Text as={'span'}>
                                            {
                                                shopUrl && shopUrl != "" ?
                                                    <Link removeUnderline target='_blank' url={shopUrl}>
                                                        <InlineStack gap='100'>
                                                            <Text as='span'>{shopifyorderId ? `${orderId} ( ${shopifyorderId} )` : orderId}</Text>
                                                            <Icon source={ExternalSmallMinor} tone="base" />
                                                        </InlineStack>
                                                    </Link>
                                                    : "-"
                                            }
                                        </Text>
                                    </InlineStack>
                                </div>
                            </InlineStack>
                        }
                        subtitle={order_row?.source_created_at ? `${formatDateForOrderCreation(months, order_row?.source_created_at, t)} ${t("from Amazon (via import)")}` : t("N/A")}
                        compactTitle
                        // primaryAction={
                        //     <RenderHeadersAction {...props} />
                        // }
                        secondaryActions={
                            order_row?.marketplace_status != "Canceled" ? ['FR', 'IN', 'IT', 'ES', 'GB', 'US'].includes(country) ? [
                                {
                                    content: t('Purchase Buy shipping'),
                                    onAction: () => props.history('../buyShipping', { state: order_row }),
                                },
                            ] : [] : []
                        }
                        pagination={{
                            hasPrevious: currentOrderIdCount !== 1,
                            onPrevious: () => {
                                let tempCount: number = currentOrderIdCount - 1;
                                setCurrentOrderCount(tempCount)
                                getOrderData(true, tempCount)
                            },
                            onNext: () => {
                                let tempCount: number = currentOrderIdCount + 1;
                                setCurrentOrderCount(tempCount)
                                getOrderData(true, tempCount)
                            },
                            hasNext: currentOrderIdCount !== +params?.total,
                        }}
                    >
                        <Layout>
                            <Layout.Section>
                                <BlockStack gap="400">
                                    <BannerCarousel row={order_row} getOrderData={getOrderData} />
                                    <OrderDetails row={order_row} />
                                    {/* Order timeline will be implemented in future  */}
                                    {/* <OrderTimeline row={order_row} />    */}
                                    <TrackingInfoTable trackingData={shippingData} />
                                </BlockStack>
                            </Layout.Section>
                            <Layout.Section variant="oneThird">
                                <BlockStack gap="400">
                                    <Card roundedAbove='sm'>
                                        <BlockStack gap="500">
                                            <Text variant="headingMd" as="h6">{t("Order Summary")}</Text>
                                            <Bleed marginInline="500"><Divider /></Bleed>
                                            {
                                                order_row?.attributes &&
                                                <React.Fragment>
                                                    <BlockStack gap="0">
                                                        <Text variant="headingMd" as="h6">{t("Ship By:")}</Text>
                                                        <Text variant="headingMd" as="h6" fontWeight='medium' tone="caution">{formattedOrderSummaryDate(months, order_row?.attributes?.filter((attr: any) => attr?.key === 'Amazon LatestShipDate')?.[0]?.value, t) || t("N/A")}</Text>
                                                    </BlockStack>
                                                    <BlockStack gap="0">
                                                        <Text variant="headingMd" as="h6">Deliver By:</Text>
                                                        <Text variant="headingMd" as="h6" fontWeight='medium'>
                                                            {order_row?.attributes?.filter((attr: any) => attr?.key === 'Amazon LatestDeliveryDate')?.length !== 0 ? formattedOrderSummaryDate(months, order_row?.attributes?.filter((attr: any) => attr?.key === 'Amazon LatestDeliveryDate')?.[0]?.value, t) : t("N/A") || t("N/A")}
                                                        </Text>
                                                    </BlockStack>
                                                </React.Fragment>
                                            }
                                            <BlockStack gap="0">
                                                <Text variant="headingMd" as="h6">{t("Shipping Service:")}</Text>
                                                {
                                                    order_row?.shipping_details?.method ?
                                                        <Text variant="headingMd" as="h6" fontWeight='medium'>{order_row?.shipping_details?.method}</Text>
                                                        : t("N/A")
                                                }
                                            </BlockStack >
                                        </BlockStack >
                                    </Card >
                                    {/* {
                                        order_row?.shipping_address &&
                                        order_row?.shipping_address?.length > 0 &&
                                        <Card roundedAbove='sm'>
                                            <BlockStack gap="500">
                                                <Text variant="headingMd" as="h6"> {t("Ship To")}</Text>
                                                {

                                                }
                                            </BlockStack >
                                        </Card >
                                    } */}
                                    {
                                        order_row?.shipping_address &&
                                        order_row?.shipping_address?.length > 0 &&
                                        <Card roundedAbove='sm'>
                                            <BlockStack gap="500">
                                                <Text variant="headingMd" as="h6"> {t("Ship To")}</Text>
                                                {
                                                    order_row?.shipping_address?.map((data: any, idx: number) => {
                                                        return (
                                                            <React.Fragment key={idx}>
                                                                <Bleed marginInline="500"><Divider /></Bleed>
                                                                <BlockStack gap="0">
                                                                    <Text variant="headingMd" as="h6">{t("Address")}</Text>
                                                                    <Text variant="headingMd" as="h6" fontWeight='medium'>{data?.name || "-"}</Text>
                                                                    {
                                                                        (data?.address_line_1 || data?.address_line_1 || data?.address_line_1)
                                                                        &&
                                                                        <Text variant="headingMd" as="h6" fontWeight='medium'>
                                                                            {data?.address_line_1 || data?.address_line_1 || data?.address_line_1}
                                                                        </Text>
                                                                    }
                                                                    {
                                                                        data?.zip &&
                                                                        <Text variant="headingMd" as="h6" fontWeight='medium'>{data?.zip}</Text>
                                                                    }
                                                                </BlockStack >
                                                                {
                                                                    data?.phone &&
                                                                    <BlockStack gap="0">
                                                                        <Text variant="headingMd" as="h6">{t("Phone Number")}</Text>
                                                                        <Text variant="headingMd" as="h6" fontWeight='medium'>{data?.phone?.includes('ext') ? data?.phone?.split('ext')[0] : data?.phone}</Text>
                                                                        <Text variant="headingMd" as="h6" fontWeight='medium' tone='subdued'>{data?.phone?.includes('ext') ? 'ext ' + data?.phone?.split('ext')[1] : ""}</Text>
                                                                    </BlockStack >
                                                                }
                                                            </React.Fragment >
                                                        );
                                                    })
                                                }
                                            </BlockStack >
                                        </Card >
                                    }
                                    <Card roundedAbove='sm'>
                                        <BlockStack gap="500">
                                            <Text variant="headingMd" as="h6">{t("Order Summary")}</Text>
                                            <Bleed marginInline="500"><Divider /></Bleed>
                                            <InlineStack gap="200">
                                                {renderTagStructure()}
                                            </InlineStack>
                                        </BlockStack >
                                    </Card >
                                </BlockStack >
                            </Layout.Section >
                        </Layout >
                    </Page >
            }
        </div >
    );
}

export default DI(ViewOrders);